import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute, effect, inject, input, linkedSignal, numberAttribute, signal } from '@angular/core';
import { Mode } from 'src/app/components/consulting-reservation';
import { Step1Component } from 'src/app/components/consulting-reservation/step1/step1.component';
import { Step2SimpleComponent } from 'src/app/components/consulting-reservation/step2-simple/step2.component';
import { Step2Component } from 'src/app/components/consulting-reservation/step2/step2.component';

@Component({
  selector: 'app-consultation-reservation',
  imports: [
    Step1Component,
    Step2Component,
    Step2SimpleComponent
  ],
  templateUrl: './consulting-reservation.component.html',
  styleUrl: './consulting-reservation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConsultingReservationComponent {
  readonly #location = inject(Location);

  readonly mode = signal<Mode>('step1');

  readonly bannerPc = input<string | null>(null);
  readonly bannerSp = input<string | null>(null);
  readonly step = input<Mode>('step1');
  readonly isSimple = input(true, { transform: booleanAttribute });
  readonly lpType = input<string | null>(null);
  readonly discount = input(10, { transform: numberAttribute });
  readonly isCasual = input(false, { alias: 'casual', transform: booleanAttribute });
  readonly isColorful = input(false, { alias: 'colorful', transform: booleanAttribute });
  readonly completeUrl = input<string>('');

  protected complete = linkedSignal(() => {
    const completeUrl = this.completeUrl();
    const isCasual = this.isCasual();
    if (completeUrl) {
      return completeUrl;
    }

    return isCasual ? '/ab/light-counseling-complete' : '/ab/counseling-complete';
  });

  readonly cities = input('');
  readonly countries = input('');

  constructor() {
    this.#parseQuery();
    this.#location.onUrlChange(() => {
      this.#parseQuery();
    })
  }

  #parseQuery() {
    const params = new URLSearchParams(window.location.search);
    this.mode.set(params.get('step') as Mode ?? 'step1');
  }
}
